(function() {
  'use strict';

  function cleanupPromoCards() {
    // Only run if HTML has child-selected class
    if (!document.documentElement.classList.contains('child-selected')) {
      console.log('[PromoCardCleanup] No child selected, skipping cleanup');
      return;
    }

    // Find all promo cards that should NOT show when child is selected
    const promoCards = document.querySelectorAll('.promo-placeholder[data-show-when-child-selected="false"]');

    if (promoCards.length === 0) {
      console.log('[PromoCardCleanup] No promo cards found to remove');
      return;
    }

    console.log(`[PromoCardCleanup] Removing ${promoCards.length} promo card(s) from DOM`);

    promoCards.forEach(card => {
      console.log('[PromoCardCleanup] Removing promo card:', card.dataset.promoId || 'unknown');
      card.remove();
    });

    console.log('[PromoCardCleanup] Cleanup complete');
  }

  // Run cleanup when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupPromoCards);
  } else {
    // DOM already loaded, run immediately
    cleanupPromoCards();
  }

  // Also listen for child selection changes (in case child is selected after page load)
  document.addEventListener('stateChanged', function(e) {
    if (e.detail && e.detail.key === 'currentChildId' && e.detail.value) {
      // Child was just selected, cleanup promo cards
      setTimeout(cleanupPromoCards, 100); // Small delay to ensure DOM is updated
    }
  });
})();
